"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliceRegistry = void 0;
const constants_1 = require("../slice/constants");
const slice_1 = require("../slice");
const printTree_1 = require("tree-dump/lib/printTree");
/**
 * Slice registry contains a record of possible inline an block formatting
 * annotations. Each entry in the registry is a {@link SliceBehavior} that
 * specifies the behavior, tag, and other properties of the slice.
 *
 * @todo Consider moving the registry under the `/transfer` directory. Or maybe
 * `/slices` directory.
 */
class SliceRegistry {
    constructor() {
        this.map = new Map();
        this._fromHtml = new Map();
    }
    clear() {
        this.map.clear();
        this._fromHtml.clear();
    }
    add(entry) {
        const { tag, fromHtml } = entry;
        this.map.set(tag, entry);
        const _fromHtml = this._fromHtml;
        if (fromHtml) {
            for (const htmlTag in fromHtml) {
                const converter = fromHtml[htmlTag];
                const converters = _fromHtml.get(htmlTag) ?? [];
                converters.push([entry, converter]);
                _fromHtml.set(htmlTag, converters);
            }
        }
        const tagStr = slice_1.CommonSliceType[tag];
        if (tagStr && typeof tagStr === 'string' && (!fromHtml || !(tagStr in fromHtml)))
            _fromHtml.set(tagStr, [[entry, () => [tag, null]]]);
    }
    get(tag) {
        return this.map.get(tag);
    }
    isContainer(tag) {
        const entry = this.map.get(tag);
        return entry?.container ?? false;
    }
    toHtml(el) {
        const entry = this.map.get(el[0]);
        return entry?.toHtml ? entry?.toHtml(el) : void 0;
    }
    fromHtml(el) {
        const tag = el[0] + '';
        const converters = this._fromHtml.get(tag);
        if (converters) {
            for (const [entry, converter] of converters) {
                const result = converter(el);
                if (result) {
                    if (entry.isInline()) {
                        const attr = result[1] ?? (result[1] = {});
                        attr.inline = entry.isInline();
                        attr.stacking = !attr.inline ? constants_1.SliceStacking.Marker : (entry.stacking ?? constants_1.SliceStacking.Many);
                    }
                    return result;
                }
            }
        }
        return;
    }
    /** ----------------------------------------------------- {@link Printable} */
    toString(tab = '') {
        return ('Registry' +
            (0, printTree_1.printTree)(tab, [...this.map.values()].map((entry) => (tab) => entry.toString(tab))));
    }
}
exports.SliceRegistry = SliceRegistry;
